import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EmployeeProfile } from '../EmployeeProfile';
import { EmployeeList } from '../EmployeeList';

interface DashboardTabsProps {
  isAdmin: boolean;
}

export const DashboardTabs = ({ isAdmin }: DashboardTabsProps) => {
  return (
    <Tabs defaultValue="profile">
      <TabsList>
        <TabsTrigger value="profile">My Profile</TabsTrigger>
        {isAdmin && <TabsTrigger value="employees">Employees</TabsTrigger>}
      </TabsList>
      <TabsContent value="profile">
        <EmployeeProfile />
      </TabsContent>
      {isAdmin && (
        <TabsContent value="employees">
          <EmployeeList />
        </TabsContent>
      )}
    </Tabs>
  );
};